import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { RoutingProfileAction } from './routingProfile.action';
import { routingProfileInitialState } from './routingProfile.constant';

export const routingProfileReducer = reducerWithInitialState(routingProfileInitialState)
  .case(RoutingProfileAction.loadList.started, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(RoutingProfileAction.loadList.done, (state, { result }) => {
    const data = {};
    Object.values(result.data).forEach((item) => {
      data[item.id] = item;
    });

    return {
      ...state,
      data,
      defaultData: result.defaultData ?? routingProfileInitialState.defaultData,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(RoutingProfileAction.loadList.failed, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })
  .case(RoutingProfileAction.create.done, (state, payload) => {
    const { routingProfileId } = payload.result;
    const profile = payload.params;
    return {
      ...state,
      data: {
        ...state.data,
        [routingProfileId]: { ...profile, id: routingProfileId, networkStatus: NetworkStatus.Done },
      },
    };
  })
  .case(RoutingProfileAction.update.done, (state, payload) => {
    const profile = payload.params;
    return {
      ...state,
      data: {
        ...state.data,
        [profile.id]: { ...profile, networkStatus: NetworkStatus.Done },
      },
    };
  })
  .case(RoutingProfileAction.remove.done, (state, payload) => {
    const { routingProfileId } = payload.params;
    const { [routingProfileId]: _, ...rest } = state.data;
    return {
      ...state,
      data: rest,
    };
  })
  .case(RoutingProfileAction.destroy, () => ({
    ...routingProfileInitialState,
  }));
